<div class="mx-auto px-4">
  <div class="hidden md:block overflow-x-auto">
    <div class="mb-4">
      <p class="titre1 mt-4">
        {{ 'PARAMETRE_ENTITE.TITLE' | translate }}
        <mat-icon
        class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">settings</mat-icon>
      </p>
    </div>

    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }

    @if (!isLoading) {
      <div class="flex items-end justify-end mb-4 gap-3">
        <mat-select [(ngModel)]="filtreType" (selectionChange)="filtre()"
          placeholder="{{ 'PARAMETRE_ENTITE.ALL' | translate }}"
          class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="220">
          <mat-option value="Nom">{{ 'PARAMETRE_ENTITE.NOM' | translate }}</mat-option>
          <mat-option value="Neq">{{ 'PARAMETRE_ENTITE.NEQ' | translate }}</mat-option>
          <mat-option value="IdUnique">{{ 'PARAMETRE_ENTITE.IDUNIQUE' | translate }}</mat-option>
        </mat-select>
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="filtre()"
          placeholder="{{ 'PARAMETRE_ENTITE.SEARCH' | translate }}..."
          class="h-8 w-46 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
          <button mat-icon-button (click)="reinitialiserFiltre()" class="h-1/12 w-8 bg-white-200 text-white-600 rounded"
            title="Réinitialiser">
            <mat-icon>restore</mat-icon>
          </button>
        </div>
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortDataChange($event)"
          class="mat-table-novo">
          <ng-container matColumnDef="nom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-2/5 px-4 py-2">
              {{ 'PARAMETRE_ENTITE.NOM' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-2/5 px-4 py-2 border-b">
              {{ element.nom }}
            </td>
          </ng-container>
          <ng-container matColumnDef="raisonSociale">
            <th mat-header-cell *matHeaderCellDef class="table-cell w-1/10 px-4 py-2">
              {{ 'PARAMETRE_ENTITE.RAISONSOCIALE' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
              {{ element.raisonSociale }}
            </td>
          </ng-container>
          <ng-container matColumnDef="nomLegal">
            <th mat-header-cell *matHeaderCellDef class="table-cell w-1/10 px-4 py-2">
              {{ 'PARAMETRE_ENTITE.NOMLEGAL' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
              {{ element.nomLegal }}
            </td>
          </ng-container>
          <ng-container matColumnDef="estActif">
            <th mat-header-cell *matHeaderCellDef class="table-cell w-1/10 px-4 py-2">
              {{ 'PARAMETRE_ENTITE.ESTACTIF' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
              {{ element.estActif ? 'Oui' : 'Non' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="neq">
            <th mat-header-cell *matHeaderCellDef class="table-cell w-1/10 px-4 py-2">
              {{ 'PARAMETRE_ENTITE.NEQ' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
              {{ element.neq }}
            </td>
          </ng-container>
          <ng-container matColumnDef="idUnique">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-3/10 px-4 py-2">
              {{ 'PARAMETRE_ENTITE.IDUNIQUE' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-3/10 px-4 py-2 border-b">
              {{ element.idUnique }}
            </td>
          </ng-container>
          <ng-container matColumnDef="estRaisonSocialeAffiche">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-1/10 px-4 py-2">
              {{ 'PARAMETRE_ENTITE.ESTRAISONSOCIALEAFFICHE' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
              {{ element.estRaisonSocialeAffiche ? 'Oui' : 'Non' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.ACTIONS' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">
              <button mat-icon-button (click)="editOrganisation(element.entiteId)">
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
        </table>
        @if (dataSource.filteredData.length === 0) {
          <div class="text-center mt-2 text-gray-500">
            {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
          </div>
        }
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
          (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
        </mat-paginator>
      }
    </div>
  </div>
